import ResetPasswordForm from "../../features/authentication/newPassword/ResetPasswordForm";

function ResetPassword() {
    return (
        <>
            <main className="container mx-auto">
                <ResetPasswordForm />
            </main>
        </>
    );
}

export default ResetPassword;
